import { render, staticRenderFns } from "./OrderStockAllocation.vue?vue&type=template&id=a10937b4&scoped=true&"
import script from "./OrderStockAllocation.vue?vue&type=script&lang=ts&"
export * from "./OrderStockAllocation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10937b4",
  null
  
)

export default component.exports